import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { MedVoxEvent } from '../../models/MedVox/MedVoxEvent';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';

export interface MedVoxEventState {
  items: MedVoxEvent[];
  totalItemsCount: 0;
  status: Status;
}

const initialState: MedVoxEventState = {
  items: [],
  totalItemsCount: 0,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export interface MedVoxEventResponse {
  items: MedVoxEvent[];
  totalItemsCount: 0;
}

export interface MedVoxEventRequest {
  selectedDate: string;
  Filter: string;
  PageIndex: number;
  PageSize: number;
}

export const getMedVoxEvents = createAsyncThunk(
  'roboEvent/event-medvox-list',
  async (request: MedVoxEventRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<MedVoxEventResponse>(
        'events',
        {
          params: {
            Filter: request.Filter,
            PageIndex: request.PageIndex,
            PageSize: request.PageSize,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить список событий!');
    }
  },
);

export const medVoxEventSlice = createSlice({
  name: 'medVoxEvent',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getMedVoxEvents.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.items = action.payload.items;
        state.totalItemsCount = action.payload.totalItemsCount;
        return state;
      })
      .addCase(getMedVoxEvents.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список событий';
      });
  },
});

export default medVoxEventSlice.reducer;

export const selectMedVoxEvents = (state: RootState) => state.medVoxEvent.items;
export const medVoxStatus = (state: RootState) => state.medVoxEvent.status;
export const totalMedVoxEvents = (state: RootState) =>
  state.medVoxEvent.totalItemsCount;
